import { HttpClient, HttpHandler, HttpXhrBackend } from '@angular/common/http'
import { Injector } from '@angular/core'
import { of } from 'rxjs'
let http: HttpClient

const STRINGKEY_ACCESSOR = 'ATYL_STRINGABLE_VALUES'

export const Stringable = (options: StringableOptions) => {

	if (undefined === window[STRINGKEY_ACCESSOR]) {
		window[STRINGKEY_ACCESSOR] = {}
	}
	const KEY = keyfiy(options.key)
	window[STRINGKEY_ACCESSOR][KEY] = {}
	return (target: any) => {
		if (!options.path || !options.key) {
			throw new Error('path and key are requireds to use Stringable decorator ')
		}
		const injector = Injector.create({
			providers: [
				{ provide: HttpClient, deps: [HttpHandler] },
				{ provide: HttpHandler, useValue: new HttpXhrBackend({ build: () => new XMLHttpRequest }) }
			]
		})
		http = injector.get(HttpClient)
		getStrings(options.path).subscribe(res => {
			window[STRINGKEY_ACCESSOR][KEY] = res
		})
	}
}
export const StringableValues = (key: string) => {

	const KEY = keyfiy(key)
	return function (target: Object, propertyKey: string) {
		const getter = function () {
			return window[STRINGKEY_ACCESSOR][KEY]
		}
		Object.defineProperty(target, propertyKey, {
			get: getter
		})
	}
}
function getStrings(path: string) {
	return http.get(getFullpath(path)) || of({})
}
function getFullpath(path: string) {
	return `assets/strings/${path}.json`
}


function keyfiy(key: string) {
	return key.replace(/[-_]/g, '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}

export interface StringableOptions {
	path: string
	key: string
}
